import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { XTabNav } from '@/components/xqxc_ui';
import TransactionList from './transactionlist';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const tabList = [
    { id: 1, label: '交易明细' }
];

const Detail = (props) => {

    const [curTabID, setCurTabID] = useState(1);

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
            {curTabID === 1 && <TransactionList {...props} />}
        </div>
    );
};

Detail.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Detail);